export default __webpack_public_path__ + "static/media/Vector.4d90b47d.svg";